enum PortalRegistrationState {
    Default = 100,
    RegistrationPending = 101,
    PortalRefused = 102,
    RegistrationComplete = 103,
    ChildAccount = 104,
    InvitationLocked = 105
}

export { PortalRegistrationState };
